const IMG = "https://static.prod-images.emergentagent.com/jobs/5eff8c1f-b59e-44ca-87ee-9b0bceebb3f3/images/";

// For Owners — premium canine programs (B2C)
const OWNER_PROGRAMS = [
  {
    slug: "protection-trained-boerboels",
    category: "B2C",
    title: "Protection-Trained Guardian Boerboels",
    tagline: "Family-safe. Fully trained. Truly formidable.",
    priceFrom: "From $25,000",
    price: 25000,
    ctaText: "Request Consultation",
    image: IMG + "0f6909a781de2f7030bb4ada27ba58f22fe7f98cf7a2fa0423c525b8ae3a3173.jpeg",
    summary:
      "Personal and family protection Boerboels raised and titled to the E.O.N standard. Each dog is temperament-tested, obedience-finished and threat-trained, then matched to your home and lifestyle.",
    features: [
      "Level I–III protection & obedience titles",
      "Health-tested, DNA-verified, registered papers",
      "Delivered with handler onboarding",
      "Lifetime E.O.N owner support & retraining tune-ups",
    ],
    process: ["Consultation & needs assessment", "Dog matching & reservation", "Final proofing & handler training", "White-glove delivery"],
  },
  {
    slug: "board-and-train",
    category: "B2C",
    title: "E.O.N Board & Train",
    tagline: "Send us your dog. Get back a professional.",
    priceFrom: "From $4,500 / program",
    price: 4500,
    ctaText: "Book a Program",
    image: IMG + "2896499c76d444eea38ef86199ba9865bc8aaf45dd2f3a4ec06c2b176b4977b8.jpeg",
    summary:
      "Immersive on-site programs at the E.O.N facility. From foundational obedience to advanced off-leash control and protection work, your dog trains daily with our team, then you train with us before pickup.",
    features: [
      "2, 4 and 8-week structured tracks",
      "Off-leash reliability & impulse control",
      "Optional protection & guardian modules",
      "Weekly progress video reports",
    ],
    process: ["Intake & evaluation", "Daily structured training", "Owner transfer sessions", "Graduation & follow-up plan"],
  },
  {
    slug: "elite-stud-service",
    category: "B2C",
    title: "Elite Stud Service",
    tagline: "Proven sires. Verified genetics.",
    priceFrom: "From $3,500 / stud fee",
    price: 3500,
    ctaText: "Apply for Breeding",
    image: IMG + "8f3c3d53c0041e3339495e3e54beb5a3871dcf0fa0164ce05ea81e1f0224ee32.jpeg",
    summary:
      "Access championship E.O.N bloodlines. Our proven, health-cleared sires are available to approved dams by natural cover or fresh/chilled artificial insemination.",
    features: [
      "OFA / DNA health-cleared males",
      "Live cover, fresh & chilled AI options",
      "Breeding contract & pick-of-litter terms",
      "Repeat breeding guarantee",
    ],
    process: ["Dam application & health review", "Contract & scheduling", "Breeding & confirmation", "Whelping support"],
  },
];

// E.O.N Business Solutions — high-ticket done-for-you ladder (B2B)
const BUSINESS_SOLUTIONS = [
  {
    slug: "breeder-business-launch",
    category: "B2B",
    title: "Breeder Business Launch",
    tagline: "For new breeders who need real business infrastructure.",
    priceFrom: "Starting at $2,500",
    price: 2500,
    ctaText: "Book Consultation",
    image: IMG + "4285f9b22a8767352b93caa7251c508d4bf18a1dffeffb266fcce8392a01cf5c.jpeg",
    summary:
      "Everything a new breeder needs to operate like a professional business from day one — strategy, positioning, intake and a clean digital workflow.",
    features: ["Business strategy & brand positioning", "Customer intake & digital workflow",
               "Website & marketplace consultation", "Business profile & customer systems"],
    process: ["Discovery consultation", "Strategy blueprint", "Setup & onboarding", "Launch support"],
  },
  {
    slug: "digital-kennel-system",
    category: "B2B",
    title: "Digital Kennel System",
    tagline: "Your breeder business's digital operating infrastructure.",
    priceFrom: "Starting at $3,500",
    price: 3500,
    ctaText: "Build My System",
    image: IMG + "0c3615537fe241574da19c18b97cfc0cfba575d6f5a813a259daf3cc39ab9813.jpeg",
    summary:
      "A complete digital backbone for a modern kennel — website, CRM, lead capture, waitlist and client portal, wired together and ready to run.",
    features: ["Website & customer intake", "CRM & lead capture", "Waitlist system & email automation",
               "Client portal & digital forms"],
    process: ["Requirements workshop", "Build & configuration", "Data & workflow setup", "Handover & training"],
  },
  {
    slug: "website-crm-buildout",
    category: "B2B",
    title: "Website + CRM Buildout",
    tagline: "Premium done-for-you digital infrastructure.",
    priceFrom: "Starting at $5,000",
    price: 5000,
    ctaText: "Request Consultation",
    image: IMG + "30fee1fa3382c136228071968895f491866563ceedb78d57391d4f2244a508fa.jpeg",
    summary:
      "A high-end website and CRM system with a full lead funnel, automations, customer portal and analytics — built for growth.",
    features: ["Website + CRM + lead funnel", "Forms & automations", "Customer portal & analytics",
               "Email workflows & appointment system"],
    process: ["Scope & design", "Build & integrate", "Automation setup", "Launch & optimize"],
  },
  {
    slug: "breeder-growth-system",
    category: "B2B",
    title: "Breeder Growth System",
    tagline: "Growth infrastructure for established breeders.",
    priceFrom: "Starting at $5,000",
    price: 5000,
    ctaText: "Apply Now",
    image: IMG + "e55c52c9afcc0ff9a9e7831cd1c9b6a717201fc17526f709abd4b90fdc9181dc.jpeg",
    summary:
      "A growth engine for established programs — audit, brand strategy, optimized funnel, CRM and follow-up systems that compound over time.",
    features: ["Business audit & brand strategy", "Website optimization & lead funnel",
               "CRM & customer journey", "Follow-up & marketing infrastructure"],
    process: ["Business audit", "Growth strategy", "Implementation", "Ongoing optimization"],
  },
  {
    slug: "business-accelerator",
    category: "B2B",
    title: "E.O.N Business Accelerator",
    tagline: "Premium consulting + implementation program.",
    priceFrom: "$7,500+",
    price: 7500,
    ctaText: "Apply for Accelerator",
    image: IMG + "0f6909a781de2f7030bb4ada27ba58f22fe7f98cf7a2fa0423c525b8ae3a3173.jpeg",
    summary:
      "A hands-on program for serious breeder businesses and dog-industry companies — strategy, infrastructure, acquisition systems and private consulting.",
    features: ["Business & brand strategy", "Digital infrastructure & CRM",
               "Customer acquisition systems", "Marketplace positioning & private consulting"],
    process: ["Application & fit call", "Program design", "Implementation sprints", "Private consulting"],
  },
  {
    slug: "elite-business-buildout",
    category: "B2B",
    title: "E.O.N Elite Business Buildout",
    tagline: "High-ticket, done-for-you implementation.",
    priceFrom: "$10,000+",
    price: 10000,
    ctaText: "Request a Proposal",
    image: IMG + "2896499c76d444eea38ef86199ba9865bc8aaf45dd2f3a4ec06c2b176b4977b8.jpeg",
    summary:
      "Not just consulting — E.O.N builds the digital infrastructure of your business end to end: premium site, brand system, CRM, funnels, portal and automations.",
    features: ["Premium website & brand system", "CRM + lead generation funnel",
               "Customer portal & automations", "Email/SMS workflows & payment infrastructure"],
    process: ["Discovery & proposal", "Design & architecture", "Full buildout", "Launch & operations setup"],
  },
  {
    slug: "custom-enterprise-solutions",
    category: "B2B",
    title: "Custom Enterprise Solutions",
    tagline: "For multi-location kennels, companies & associations.",
    priceFrom: "$15,000+ · Custom Quote",
    price: 15000,
    ctaText: "Talk to E.O.N",
    image: IMG + "8f3c3d53c0041e3339495e3e54beb5a3871dcf0fa0164ce05ea81e1f0224ee32.jpeg",
    summary:
      "Custom software, marketplace and membership platform development for established organizations undergoing digital transformation.",
    features: ["Custom software & marketplace development", "Membership platforms & automation",
               "Multi-location systems & dashboards", "Custom integrations & digital transformation"],
    process: ["Discovery & scoping", "Solution architecture", "Custom development", "Deployment & support"],
  },
];

export const PROGRAMS = [...OWNER_PROGRAMS, ...BUSINESS_SOLUTIONS];
export const getProgram = (slug) => PROGRAMS.find((p) => p.slug === slug);

// Financing helper (owner programs only). Business solutions use "custom scope".
export function financeText(program) {
  if (program?.category === "B2B") return "One-time payment · secure card checkout";
  const match = (program?.priceFrom || "").replace(/,/g, "").match(/\$(\d+)/);
  if (!match) return "Secure card checkout";
  const price = parseInt(match[1], 10);
  const monthly = Math.ceil(price / 36 / 5) * 5;
  return `Financing available — as low as $${monthly.toLocaleString()}/mo`;
}
